import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'

import * as tableStore from '@/store/table'

export {
  tableStore
}

/**
   * Search store.
   *
   * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
   */
export const createTableStoreMixin = (without = []) => {
  const actions = !without.includes('actions') ? mapActions(tableStore.moduleName, Object.keys(tableStore.actionTypes)) : {}
  const getters = !without.includes('getters') ? mapGetters(tableStore.moduleName, Object.keys(tableStore.getterTypes)) : {}
  const mutations = !without.includes('mutations') ? mapMutations(tableStore.moduleName, Object.keys(tableStore.mutationTypes)) : {}

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  }
}
